
export class Announcement {
  public announcementID: number;
  public customerID: number;
  public title: string;
  public description: string;
  public isActive: boolean;
  public startDate: string;
  public endDate: string;
  public createdDate: Date;
}



// WEBPACK FOOTER //
// ./src/app/models/announcement/announcement.model.ts